import { ProductSlugs } from '../types';

export function getIntegrationProductNameFromSlug(
  integrationProductSlug: string
): string {
  switch (integrationProductSlug) {
    case ProductSlugs.jiraDirectCloudIntegration:
      return 'Jira Cloud';
    case ProductSlugs.jiraOnPremIntegration:
      return 'Jira Data Center';
    case ProductSlugs.customIntegration:
      return 'Custom Integration';
    default:
      throw new Error(
        `Unsupported integration product slug ${integrationProductSlug}`
      );
  }
}
